export const FormatStandardDate = (date: string) => (
    new Intl.DateTimeFormat('en-US', {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
    }).format(new Date(date)).replaceAll(',', '')
);